<template>
    <div id="meters-report" class="pt-8">
        <labeled-card :label="$t('reports.tabTitle')">
            <v-container fluid class="pl-4">
                <v-row>
                    <v-col lg="3" md="4" sm="6">
                        <div class="label mb-2">{{ $t('reports.labels.dateConsumption') }}</div>
                        <date-picker
                            class="spacer picker"
                            :label="$t('reports.labels.input')"
                            :hideDetails="false"
                            dense
                            outlined
                            v-model="period"
                            type="month"
                        ></date-picker>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="4" sm="6">
                        <div class="label mb-2">{{ $t('reports.labels.dateConsumptionEdit') }}</div>
                        <date-picker
                            class="spacer picker"
                            :label="$t('reports.labels.input')"
                            :hideDetails="false"
                            dense
                            outlined
                            v-model="inputPeriod"
                            type="month"
                        ></date-picker>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="4" sm="6">
                        <v-btn class="spacer" dark color="info" @click.stop="generateReport">{{ $t('reports.labels.button') }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </labeled-card>
    </div>
</template>

<script>
import DatePicker from '@/components/ui/DatePicker';
import LabeledCard from '@/components/ui/LabeledCard';

export default {
    name: 'MetersReport',
    components: {
        DatePicker,
        LabeledCard
    },
    data: () => ({
        period: null,
        inputPeriod: null
    }),
    methods: {
        async generateReport() {
            if (!this.period && !this.inputPeriod) {
                return this.$store.dispatch('base/showMessage', {
                    message: 'reports.validations.fieldsError',
                    color: 'warning'
                });
            }

            const response = await this.$store.dispatch('reports/getIndications', {
                dateConsumption: this.period,
                dateConsumptionEdit: this.inputPeriod,
                filename: this.$t('reports.tabTitle')
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'reports.validations.noData',
                    color: 'warning'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#meters-report {
    height: 100%;
}
.label {
    font-weight: 500;
}
.spacer {
    width: 80%;
}
.picker * {
    margin-bottom: 0;
}

@media screen and (max-width: 1440px) {
    .spacer {
        width: 100%;
    }
}
</style>
